/**
 * HTTP contract shared between `apps/api` and `apps/web`.
 * No runtime deps — import types only where possible.
 */
export const UI_LOCALES = ['en', 'ru'];
export const USER_ROLES = ['USER', 'ADMIN'];
export const EXPORT_FORMATS = ['json', 'txt'];
export const BUTTON_HOTKEY_VALUES = ['enter', 'mod_enter'];
export const LISTS_MAX_PER_USER = 100;
export const LIST_NAME_MAX_LENGTH = 80;
export const LIST_DESCRIPTION_MAX_LENGTH = 500;
export const REASONING_EFFORT_VALUES = [
    'none',
    'minimal',
    'low',
    'medium',
    'high',
];
